const cartIconElement = document.querySelector(".header__action-item--cart");
const miniCartElement = document.querySelector(".header__action-item--cart .mini-cart");

function openMiniCart() {
  if (miniCartElement.getAttribute("aria-hidden") === "true") {
    miniCartElement.setAttribute("aria-hidden", "false");
  }
}

function closeMiniCart() {
  if (miniCartElement.getAttribute("aria-hidden") === "false") {
    miniCartElement.setAttribute("aria-hidden", "true");
  }
}

function handleCartHover(screenMatch, hasMouse) {
  if (screenMatch === true && window.theme.cartHover === true && hasMouse === true && window.theme.pageType !== 'cart') {
    cartIconElement.addEventListener("mouseenter", openMiniCart);
    cartIconElement.addEventListener("mouseleave", closeMiniCart);
  } else {
    cartIconElement.removeEventListener("mouseenter", openMiniCart);
    cartIconElement.removeEventListener("mouseleave", closeMiniCart);
  }
}

function checkScreenWidth() {
  const screenWidth = window.innerWidth;
  return screenWidth >= 768;
}

function hasMouse() {
  return matchMedia('(pointer:fine)').matches;
}

handleCartHover(checkScreenWidth(), hasMouse());
window.addEventListener("resize", function () {
  handleCartHover(checkScreenWidth(), hasMouse());
});